export default function slugify(str: string) {
    str = str.replace(/\W+/g, '-');

    if (str.length > 120) {
        str = str.slice(0, Math.min(100, str.indexOf('-', 80))) + '---';
    }

    return str;
}
